import { filter, fromPairs, toPairs } from "lodash";

export default function deleteCommaKeys(
  obj: Record<string, any>
): Record<string, any> {
  const pairs = toPairs(obj);
  const filtered = filter(pairs, pair => !pair[0].includes(","));
  return fromPairs(filtered);
}
